import type { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import { experimentalStyled } from '@mui/material/styles';

interface MainLayoutProps {
  children?: ReactNode;
}

const MainLayoutRoot = experimentalStyled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  height: '100%',
}));

const MainLayout: FC<React.PropsWithChildren<MainLayoutProps>> = ({ children }) => {
  return <MainLayoutRoot>{children || <Outlet />}</MainLayoutRoot>;
};

MainLayout.propTypes = {
  children: PropTypes.node,
};

export default MainLayout;
